var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDuplicate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Undo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.2,21.9H5.7c-1,0-1.7-0.8-1.8-1.8V7.7c0-1,0.8-1.7,1.8-1.8h8.5c1,0,1.7,0.8,1.8,1.8v12.5 C16,21.2,15.2,21.9,14.2,21.9z M5.7,7.4c-0.1,0-0.3,0.1-0.3,0.3v12.5c0,0.1,0.1,0.2,0.3,0.3h8.5c0.1,0,0.2-0.1,0.3-0.3V7.7 c0-0.1-0.1-0.3-0.3-0.3L5.7,7.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.7,18.1c-0.4,0-0.8-0.3-0.8-0.8c0-0.4,0.3-0.8,0.8-0.8c0.4,0,0.7-0.3,0.7-0.7V4.3c0-0.4-0.3-0.7-0.7-0.7 h-7.6c-0.4,0-0.7,0.3-0.7,0.7C9.4,4.7,9.1,5,8.7,5S7.9,4.7,7.9,4.3c0-1.2,1-2.2,2.2-2.2h7.6c1.2,0,2.2,1,2.2,2.2v11.6 C19.9,17.1,18.9,18.1,17.7,18.1z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate);
export default __webpack_public_path__ + "static/media/duplicate.d6784e40.svg";
export { ForwardRef as ReactComponent };